export const USERS_ADDED_FROM = [
  'all',
  'excel_sheet',
  'url',
  'api',
  'conversation',
  'friday_excel_sheet',
  'thursday_excel_sheet',
]


export const USERS_ADDED_TO = [
  'excel_sheet',
  'url',
  'api',
  'conversation',
  'friday_excel_sheet',
  'thursday_excel_sheet',
]

export const ADDED_FROM = {
  instagram: {
    all: 'الكل',
    api: 'الموقع',
    excel_sheet: 'ملف اكسيل',
    url: 'لينك',
    conversation: 'المحادثات',
  },
  whatsapp: {
    all: 'الكل',
    api: 'الموقع',
    excel_sheet: 'ملف اكسيل',
    url: 'لينك',
    conversation: 'المحادثات',
    friday_excel_sheet: 'ملف اكسيل يوم الجمعة',
    thursday_excel_sheet: 'ملف اكسيل يوم الخميس',
  },
}

export const USERS_FROM = {
  all: [],
  excel_sheet: [],
  url: [],
  api: [],
  conversation: [],
  friday_excel_sheet: [],
  thursday_excel_sheet : [],
}

